<onsip-loading-container
  [deferCond]="loadingStateComplete$"
  [loadingMessage]="'ONSIP_I18N.SAVING_CHANGES'"
>
  <form
    [formGroup]="formGroup"
    onsipFormTracking
    name="admin-phone-info-edit"
    id="admin-phone-info-edit"
    (ngSubmit)="submit()"
  >
    <div onsip-grid-placement-shelf>
      <div class="first-column">
        <section>
          <div class="mat-body-1 m-b-12">MAC Address</div>
          <div>{{ phoneInfo.macAddress | macAddress }}</div>
        </section>
        <section>
          <div class="mat-body-1 m-b-12">Make</div>
          <div>{{ phoneInfo.make }}</div>
        </section>
        <section>
          <div class="mat-body-1 m-b-12">Model</div>
          <div>{{ phoneInfo.model }}</div>
        </section>
        <section>
          <div class="mat-body-1 m-b-12">Phone password</div>
          <div>{{ phoneInfo.webPassword }}</div>
        </section>
        <section class="with-mat-form-field">
          <div class="mat-body-1 m-b-12">Time zone (GMT)</div>
          <mat-form-field appearance="outline" shouldLabelFloat="false">
            <mat-select formControlName="timezone" placeholder="Select a time zone">
              @for (timezone of timezoneOptions; track timezone) {
              <mat-option [value]="timezone.value">
                {{ timezone.text }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </section>
      </div>
      <div class="second-column">
        @if (phoneFeatures.Directory) {
        <section>
          <span class="span-with-icon">
            <mat-checkbox color="primary" class="mat-body-1" formControlName="directory">
              <mat-label>Company Directory</mat-label>
            </mat-checkbox>
            <mat-icon
              class="question-hover-icon"
              onsip-question-mark-tooltip
              matTooltipClass="onsip-tooltip-background"
              matTooltip="Polycom only. A Company directory adds all users on a selected PBX to the current phone. This option disables local changes to the directory."
              matTooltipPosition="above"
            >
              help_outline
            </mat-icon>
          </span>
        </section>
        } @if (phoneFeatures.Intercom) {
        <section>
          <span class="span-with-icon">
            <mat-checkbox color="primary" class="mat-body-1" formControlName="intercom">
              <mat-label>Intercom</mat-label>
            </mat-checkbox>
            <mat-icon
              class="question-hover-icon"
              onsip-question-mark-tooltip
              matTooltipClass="onsip-tooltip-background"
              matTooltip="Polycom VVX models only. The intercom feature allows you to talk to another user without any action required on their end."
              matTooltipPosition="above"
            >
              help_outline
            </mat-icon>
          </span>
        </section>
        } @if (phoneFeatures.NATKeepalive) {
        <section>
          <span class="span-with-icon">
            <mat-checkbox color="primary" class="mat-body-1" formControlName="natKeepalive">
              <mat-label>NAT Keepalive</mat-label>
            </mat-checkbox>
            <mat-icon
              class="question-hover-icon"
              onsip-question-mark-tooltip
              matTooltipClass="onsip-tooltip-background"
              matTooltip="NAT keepalive sends a message from one device to another to check that the link between the two is operating. OnSIP provides this service by default, so it’s not necessary to enable an additional phone based service. "
              matTooltipPosition="above"
            >
              help_outline
            </mat-icon>
          </span>
        </section>
        } @if (phoneFeatures.EasyTransfer) {
        <section>
          <span class="span-with-icon">
            <mat-checkbox color="primary" class="mat-body-1" formControlName="easyTransfer">
              <mat-label>Easy transfer</mat-label>
            </mat-checkbox>
            <mat-icon
              class="question-hover-icon"
              onsip-question-mark-tooltip
              matTooltipClass="onsip-tooltip-background"
              matTooltip="Polycom and select Cisco models only. Easy transfer allows users to transfer calls directly to another line without speaking with the other party first (also known as blind transfer)."
              matTooltipPosition="above"
            >
              help_outline
            </mat-icon>
          </span>
        </section>
        } @if (phoneFeatures.WebInterface) {
        <section>
          <span class="span-with-icon">
            <mat-checkbox color="primary" class="mat-body-1" formControlName="webInterface">
              <mat-label>Enable web interface</mat-label>
            </mat-checkbox>
            <mat-icon
              class="question-hover-icon"
              onsip-question-mark-tooltip
              matTooltipClass="onsip-tooltip-background"
              matTooltip="Enables a phone to be configured via a web interface hosted by the phone’s manufacturer. This option poses a security risk and is not recommended."
              matTooltipPosition="above"
            >
              help_outline
            </mat-icon>
          </span>
        </section>
        } @if (phoneFeatures.EndToEndEncryption) {
        <section>
          <span class="span-with-icon">
            <mat-checkbox color="primary" class="mat-body-1" formControlName="endToEndEncryption">
              <mat-label>End to End Encryption</mat-label>
            </mat-checkbox>
            <mat-icon
              class="question-hover-icon"
              onsip-question-mark-tooltip
              matTooltipClass="onsip-tooltip-background"
              matTooltip="Enables SDES-SRTP encryption of all media to and from the device."
              matTooltipPosition="above"
            >
              help_outline
            </mat-icon>
          </span>
        </section>
        } @if (phoneFeatures.DigitMap) {
        <section>
          <mat-form-field appearance="outline">
            <mat-label>Custom digit map</mat-label>
            <!-- digitmap is limited to 768 byte -->
            <input matInput maxlength="768" formControlName="digitMap" />
            <mat-hint
              >Changes the default length of digits required for an extension to dial
              automatically</mat-hint
            >
          </mat-form-field>
        </section>
        } @if (noFeatures) {
        <section>
          <span>
            Advanced features are unavailable for this make and model. To see which makes and models
            feature advanced options,
            <a class="support-link" href="https://support.onsip.com" target="_blank"
              >visit the knowledgebase.</a
            >
          </span>
        </section>
        }
      </div>
    </div>
    <div class="page-view-controls">
      <button
        mat-button
        type="button"
        class="toggle-button"
        color="primary"
        (click)="toggleInfoPanel()"
      >
        Cancel
      </button>
      <button mat-flat-button type="submit" class="toggle-button" color="primary">
        Save Changes
      </button>
    </div>
  </form>
</onsip-loading-container>
